"use client"
import useIsMounted from '@/hooks/useIsMounted'
import React, { useEffect, useState } from 'react'
import { Toaster } from 'react-hot-toast'

const ToasterProvider = () => {
    const isMounted = useIsMounted()
    if (!isMounted) return null

    return <Toaster />
}

export default ToasterProvider
